<div class="bg-color-base-3100 h-100vh text-align-center">
    <grid-row class="justify-content-center align-content-center h-600 pt-50">
        <grid-col col="8" class="h-100">
            <grid-row class="h-100 justify-content-center align-content-between">
                <grid-col col="12">
                    <ng-icon iconClass="icon-review-success" width="100" height="100"></ng-icon>
                </grid-col>
                <grid-col col="12" >
                    <div class="font-600 font-size-32px color-base-2200 line-h-40 mt-40 letter-spacing-3">
                        {{"YourApplicationUnderReview" | translate}}
                    </div>
                    <div class="font-400 font-size-16px color-base-700 line-h-22 mt-10 letter-spacing-1">
                        {{"NotifiedBusinessDays" | translate}}
                    </div>
                </grid-col>
          
                <grid-col col="12">
                    <grid-row class="justify-content-center">
                        <grid-col col="10" mobile="11">
                            <grid-row class="mt-10">
                                <grid-col col="12">
                                    <button class="btn-dft-border" (click)="dashboard()">
                                        {{ "DONE" | translate }}
                                    </button>

                                </grid-col>
                            </grid-row>
                        </grid-col>
                    </grid-row>
                </grid-col>
            </grid-row>
        </grid-col>
    </grid-row>
</div>